<template>
    <div class="order-table-container">
        <div class="pt-0">
            <table class="table table-striped">
                <thead class="th-wrap">
                    <tr>
                        <th scope="col" class="th-label">Item</th>
                        <th scope="col" class="th-label text-right">SKU</th>
                        <th scope="col" class="th-label text-center">Quantity ({{ orders[item_index].lists ? renderQty() : '3' }})</th>
                        <th scope="col" class="th-label text-center">Packed ({{ orders[item_index].lists ? ''+renderSelected()+'/'+renderQty()
                         : '0/3' }})</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in orders[item_index].lists">
                    <td class="col-6">
                      <div class="d-flex align-content-center" @click="openModal(order.image, index)">
                          <img v-if="order.image === 1" src="~@/assets/pack_go/thumb-tiny-image-1.png" class="property-table-data-img-list"/>
                          <img v-if="order.image === 2" src="~@/assets/pack_go/thumb-tiny-image-2.png" class="property-table-data-img-list"/>
                          <img v-if="order.image === 3" src="~@/assets/pack_go/thumb-tiny-image-3.png" class="property-table-data-img-list"/>
                          <img v-if="order.image === 4" src="~@/assets/pack_go/thumb-tiny-image-4.png" class="property-table-data-img-list"/>
                          <div style="margin-top: auto; margin-bottom: auto;">
                            <div class="row-product-name">{{ order.name }}</div>
                            <div v-for="spec in order.specs" class="row-product-color">{{ spec.label }}: {{ spec.data }}</div>
                          </div>
                      </div>
                    </td>
                    <td @click="openModal(order.image, index)" class="col-2" style="vertical-align: middle;">
                      <div class="sku-text">{{ order.SKU }}</div>
                    </td>
                    <td @click="openModal(order.image, index)" class="col-2" style="vertical-align: middle;">
                      <div class="quantity-text">{{ order.qty }}</div>
                    </td>
                    <td class="col-2" style="vertical-align: middle;">
                        <div class="d-flex align-content-center">
                          <div v-if="order.qty > order.packed && order.packed != 0"
                              @click="table_type === 'auto' ? packOne(index) : ''"
                              :class="table_type === 'auto' ? 'count-radio' : 'count-radio-scan'">
                            <p>{{ order.packed }}</p>
                          </div>
                          <img v-if="order.qty === order.packed" src="~@/assets/pack_go/check-icon.svg" class="uncheck-radio"/>
                          <img v-if="order.packed === null || order.packed === 0"
                            @click="table_type === 'auto' ? packOne(index) : ''"
                            src="~@/assets/pack_go/circle-icon.svg"
                            :class="table_type === 'auto' ? 'uncheck-radio' : 'uncheck-radio-scan'"/>
                        </div>
                    </td>
                    <td style="width: 20px;" v-if="table_type === 'auto'">
                      <BDropdown class="row-dropdown" toggle-class="text-decoration-none" right variant="link" no-caret>
                          <template #button-content>
                            <span style="font-size: 30px; font-weight: bold; color: #112857">&#x22EE;</span>
                          </template>
                          <BDropdownItem @click="packOne(index)">Pack 1</BDropdownItem>
                          <BDropdownItem v-if="order.packed > 0" @click="unpackOne(index)" href="#">Unpack 1</BDropdownItem>
                          <BDropdownItem v-if="order.packed < order.qty" @click="packAll(index)">Pack all</BDropdownItem>
                          <BDropdownItem v-if="order.packed > 0" @click="unpackAll(index)">Unpack all</BDropdownItem>
                        </BDropdown>
                    </td>
                  </tr>
                </tbody>
            </table>
        </div>
        <BModal v-model="showModal" :hide-footer="true" :hide-header="true" :size="'md'" centered title="BootstrapVue">
            <div class="modal-image">
              <transition name="enable-scanner">
                <div
                  @mouseenter="useScanner = true"
                  @mouseleave="useScanner = false"
                  @mouseup="isScanning = false"
                  class="picking-list__barcode"
                  v-if="useScanner"
                  :class="{ 'picking-list__barcode--active': isScanning }"
                  :style="{
                  transform: `translateX(${x - 72}px) translateY(${y -
                      22}px)`,
                  }"
                ></div>
            </transition>
              <img v-if="showImage === 1" class="product-image" src="~@/assets/pack_go/image-1.jpg"/>
              <img v-if="showImage === 2" class="product-image" src="~@/assets/pack_go/image-2.jpg"/>
              <img v-if="showImage === 3" class="product-image" src="~@/assets/pack_go/image-3.jpg"/>
              <img @click="packOne(currentIndex)" src="~@/assets/pack_go/barcode-image.png" class="inner-img" alt="">
            </div>
        </BModal>
    </div>
</template>

<script>
import { BDropdown, BDropdownItem, BModal } from 'bootstrap-vue';

export default {
    components: {
        BDropdown,
        BDropdownItem,
        BModal
    },
    props: {
      item_index: {
        type: Number,
        default: 0,
      },
      table_type: {
        type: String,
        default: 'auto',
      }
    },
    data() {
      return {
        hovered: null,
        x: null,
        y: null,
        isScanning: false,
        useScanner: true,
        selected: [{isCheck: false}, {isCheck: false}, {isCheck: false}],
        has_data: false,
        showImage: 0,
        showModal: false,
        order_picked: 0,
        currentIndex: null,
        orders: [
          {
              lists: [
                  {
                      image: 1,
                      name: 'Large Picture Frame',
                      specs: [
                          {
                              label: 'Size',
                              data: 'Large'
                          },
                          {
                              label: 'Color',
                              data: 'Gray'
                          }
                      ],
                      SKU: '41-FB-2010',
                      qty: 2,
                      packed: 0,
                  },
                  {
                      image: 2,
                      name: 'Antique Fruit Bowl',
                      specs: [],
                      SKU: '87-CB-45BB',
                      qty: 1,
                      packed: 0
                  },
                  {
                      image: 3,
                      name: 'Baja Wall Rack',
                      specs: [
                          {
                              label: 'Color',
                              data: 'white'
                          }
                      ],
                      SKU: '19-AV-6747',
                      qty: 2,
                      packed: 0
                  }
              ]
          },
          {
              lists: [
                  {
                      image: 1,
                      name: 'Large Picture Frame',
                      specs: [
                          {
                              label: 'Size',
                              data: 'Large'
                          },
                          {
                              label: 'Color',
                              data: 'Gray'
                          }
                      ],
                      SKU: '41-FB-2010',
                      qty: 2,
                      packed: 0
                  },
                  {
                      image: 2,
                      name: 'Antique Fruit Bowl',
                      specs: [],
                      SKU: '87-CB-45BB',
                      qty: 1,
                      packed: 0
                  },
              ]
          },
          {
              lists: [
                  {
                      image: 3,
                      name: 'Baja Wall Rack',
                      specs: [
                          {
                              label: 'Color',
                              data: 'white'
                          }
                      ],
                      SKU: '19-AV-6747',
                      qty: 2,
                      packed: 0
                  }
              ]
          }
      ]
      }
    },
    watch: {
      selected_order: function(newVal, oldVal) {
        this.selected = [];
        if(newVal !== null) {
          newVal.forEach(element => {
            this.selected.push({isCheck: false, hyeas: 123});
          });
          this.has_data = true
          return
        }
        this.has_data = false
      }
    },
    methods: {
      packOne(listIndex) {
        if(this.orders[this.item_index].lists[listIndex].packed < this.orders[this.item_index].lists[listIndex].qty) {
          this.orders[this.item_index].lists[listIndex].packed++
        }

        if(this.table_type === 'scan') {
          if(this.orders[this.item_index].lists[listIndex].packed == this.orders[this.item_index].lists[listIndex].qty) {
            this.showModal = false
          }
        }
        
        if(this.checkList(this.orders[this.item_index])) {
          this.$emit('open-modal')
        }
      },
      unpackOne(listIndex) {
        this.orders[this.item_index].lists[listIndex].packed--
      },
      packAll(listIndex) {
        this.orders[this.item_index].lists[listIndex].packed = this.orders[this.item_index].lists[listIndex].qty
        if(this.checkList(this.orders[this.item_index])) {
          this.$emit('open-modal')
        }
      },
      unpackAll(listIndex) {
        this.orders[this.item_index].lists[listIndex].packed = 0
      },
      checkList(lists) {
        let isComplete = true;
        Object.entries(lists.lists).forEach(([key, value]) => {
          if(value.packed < value.qty) {
            isComplete = false
          }
        })
        return isComplete
      },
      renderQty() {
        return this.orders[this.item_index].lists.reduce(function (accumulator, curValue) {
            return accumulator + curValue.qty
        }, 0)
      },
      renderSelected() {
        return this.orders[this.item_index].lists.reduce(function (accumulator, curValue) {
          const toAdd = curValue.packed
          return accumulator + toAdd;
        }, 0)
      },
      openModal(img, image_index) {
        if(this.table_type === "scan") {
          this.currentIndex = image_index
          this.showModal = true
          this.showImage = img
        }
      },
      handleMouseMove(event) {
          this.x = event.clientX;
          this.y = event.clientY;
      }
    },
    created() {
        document.addEventListener("mousemove", this.handleMouseMove);
    },
    destroyed() {
        document.removeEventListener("mousemove", this.handleMouseMove);
    },
}
</script>

<style>
.table {
  margin-bottom: 0px;
}

.order-table-container {
    background-color: #ffffff;
    border: 1px solid #C3C5C7;
    border-radius: 6px;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
}

.th-wrap {
    border-top: none; 
}

.th-label {
    border-top: none !important;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: #686868;
}

.property-table-data-img-list {
    border-radius: 6px;
    width: 60px;
    height: 60px;
    margin-right: 10px;
}

.row-product-name {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  color: #212121;
}

.row-product-color {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #212121;
}

.sku-text {
  color: #212121;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  margin-left: auto;
  text-align: right;
}

.quantity-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #212121;
}

.count-radio {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  background-color: #1D97FF;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}

.count-radio-scan {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  background-color: #1D97FF;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
}

.uncheck-radio {
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  cursor: pointer;
}

.uncheck-radio-scan {
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
}

.row-dropdown {
  padding: 0px !important;
  margin-left: -60px;
}

@media (max-width: 768px) {
  .row-dropdown {
    margin-left: -20px;
  }

  .th-label {
    font-size: 11px;
  }
  
  .property-table-data-img-list {
      border-radius: 6px;
      width: 40px;
      height: 40px;
      margin-right: 5px;
  }

  .row-product-name {
    font-size: 15px;
  }

  .row-product-color {
    font-size: 11px;
    line-height: 12px;
  }

  .sku-text {
    font-size: 15px;
  }

  .quantity-text {
    font-size: 15px;
  }

  .count-radio {
    height: 30px;
    width: 30px;
  }

  .count-radio-scan {
    height: 30px;
    width: 30px;
  }

  .uncheck-radio {
    height: 30px;
    width: 30px;
  }

  .uncheck-radio {
    height: 30px;
    width: 30px;
  }
}

.row-image {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  margin-right: 16px;
}

.round {
  position: relative;
}

.round label {
  margin-top: -10px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 40px;
  right: -40px;
  position: absolute;
  top: 20px;
  width: 40px;
}

.round label:after {
  border: 0px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 0px;
  left: 20px;
  opacity: 0;
  position: absolute;
  top: 20px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #112857;
  border-color: #112857;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.table-striped>tbody>tr:nth-child(odd) {
    background-color: #F5F6FA;;
}

.uncheck-radio:hover {
  background-color: #D2EAFF;
}

.modal-image {
  display: flex;
  justify-content: center;
  align-items: center; /* Adjust the height as needed */
  position: relative;
}

.modal-image .product-image {
  width: 80%;
  border-radius: 6px;
}

.modal-image .inner-img {
  max-width: 100%;
  max-height: 100%;
  width: 20%;
  bottom: 1px;
  right: 1px;
  position: absolute;
}

.count-radio:hover {
  opacity: 0.50;
}

.count-radio p {
  text-align: center;
  margin-top: 16px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
}

.count-radio-scan p {
  text-align: center;
  margin-top: 16px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
}

.enable-scanner-enter-active,
.enable-scanner-leave-active {
    transition: opacity 0.5s ease, width 0.5s ease;
}
.enable-scanner-enter,
.enable-scanner-leave-to {
    opacity: 0;
    width: 0;
}

.picking-list__barcode {
    position: fixed;
    z-index: 1000;
    display: flex;
    width: 150px;
    animation: barcode-animation;
    animation-duration: 100ms;
    animation-iteration-count: infinite;
    pointer-events: none;
    top: 25px;
    left: 25px;
    height: 2px;
    background: rgb(255, 238, 238);
    border-radius: 3px;
    z-index: 1000;
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33),
        0px 0px 3px 1px rgba(255, 115, 115, 0.84),
        0px 0px 0px 0px rgba(255, 25, 25, 0.94),
        0px 0px 26px 26px rgba(255, 4, 4, 0.23);
}
</style>